<template>
  <div id="DetalleDeDocumento_div" class="w-100 px-0 py-0">
    <div id="TituloDetalleDeDocumento_div">
      <h6>DOCUMENTOS PARA RECEPCIÓN EN ARCHIVO (1a VEZ)</h6>
    </div>
    <div style="display: flex">
        
        <div class="col-md-12 padding">
            <div class="area">
              <div class="row">
                <div class="col-4">
                    <h6>Documentos por Área</h6>
                        <CAreas
                            v-on:valorParaElPadre="cambioDeArea" 
                            :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                            :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                            :idDelInput="'filtroDeBusqueda_Area'" 
                            :parametros="BusquedaForm.parametros_Area" 
                            >
                        </CAreas>
                </div>
                <div class="col-8 d-flex justify-content-left align-items-center">
                    <div id="BotonBusqueda_div" class="text-left">
                        <button class="btn btn-sm btn-dark"  @click='ObtenDocumentos()'>Obtener Listado</button>
                    </div>
                </div>
              </div>
              <div class="row" v-if="ListadoDeFechas.length>0">
                <div class="form-group col-4" >
                    <label class="text-success">Fecha de Listado</label>
                    <select id="catalogoDeTipos" class="form-control" @change="cambiarFechaListado($event)">
                        <option value= -1>Seleccione una fecha</option>
                        <option v-for="fechas in ListadoDeFechas" :key="fechas.Id" :value="fechas.Id" >{{fechas.FechaFormato}}</option>
                    </select>
                </div>
              </div>
            </div>
            <div class="area" v-if="listaPreviaSinFiltro.length>0 && (ListaConFormatoExpedientes.length>0 || ListaConFormatoAmparos.length>0|| ListaConAdministrativas.length>0 || ListaConDigitales.length>0 || ListaConJuicio.length>0 || ListaConEjecucion.length>0 || ListaConFormatoExpedientesPenales.length>0 || ListaConFormatoAmparosPenales.length>0 || ListaConFormatoExhortosPenales.length>0 || ListaConTocasCiviles.length>0 || ListaConTocasPenales.length>0 || ListaConTocasOrales.length>0 || ListaConTocasOralADO.length>0 || ListaConTocasOralEJE.length>0)">
              <div v-if="BusquedaForm.parametros_Area.areaId!=48 && BusquedaForm.parametros_Area.areaId!=51 && BusquedaForm.parametros_Area.areaId!=52 && BusquedaForm.parametros_Area.areaId!=53 && BusquedaForm.parametros_Area.areaId!=54">
                    <ul class="nav nav-tabs" id="myTab" role="tablist">
                      <li class="nav-item" v-if="ListaConFormatoExpedientes.length>0">
                        <a class="nav-link active" id="home-tab" data-toggle="tab" href="#Expedientes" role="tab" aria-controls="Expedientes" aria-selected="true">Expedientes Principales ({{ListaConFormatoExpedientes.length}})</a>
                      </li>
                      <li class="nav-item" v-if="ListaConFormatoAmparos.length>0">
                        <a class="nav-link" id="profile-tab" data-toggle="tab" href="#Amparos" role="tab" aria-controls="Amparos" aria-selected="false">Cuadernos de Amparo ({{ListaConFormatoAmparos.length}})</a>
                      </li>
                      <li class="nav-item" v-if="ListaConFormatoExhortos.length>0" >
                        <a class="nav-link" id="profile-tab" data-toggle="tab" href="#Exhortos" role="tab" aria-controls="Exhortos" aria-selected="false">Exhortos ({{ListaConFormatoExhortos.length}})</a>
                      </li>
                      <li class="nav-item" v-if="ListaConFormatoExpedientesPenales.length>0" >
                        <a class="nav-link" id="profile-tab" data-toggle="tab" href="#ExpedientesPenales" role="tab" aria-controls="ExpedientesPenales" aria-selected="false">Expedientes Penales ({{ListaConFormatoExpedientesPenales.length}})</a>
                      </li>
                      <li class="nav-item" v-if="ListaConDigitales.length>0">
                        <a class="nav-link" id="profile-tab" data-toggle="tab" href="#Digitales" role="tab" aria-controls="Digitales" aria-selected="false">Carpetas Digitales ({{ListaConDigitales.length}})</a>
                      </li>
                      <li class="nav-item" v-if="ListaConAdministrativas.length>0">
                        <a class="nav-link" id="profile-tab" data-toggle="tab" href="#Administrativas" role="tab" aria-controls="Administrativas" aria-selected="false">Carpetas Administrativas ({{ListaConAdministrativas.length}})</a>
                      </li>
                      <li class="nav-item" v-if="ListaConFormatoAmparosPenales.length>0" >
                        <a class="nav-link" id="profile-tab" data-toggle="tab" href="#AmparosPenales" role="tab" aria-controls="AmparosPenales" aria-selected="false">Amparos Penales ({{ListaConFormatoAmparosPenales.length}})</a>
                      </li>
                      <li class="nav-item" v-if="ListaConFormatoExhortosPenales.length>0" >
                        <a class="nav-link" id="profile-tab" data-toggle="tab" href="#ExhortosPenales" role="tab" aria-controls="ExhortosPenales" aria-selected="false">Exhortos Penales ({{ListaConFormatoExhortosPenales.length}})</a>
                      </li>
                      <li class="nav-item" v-if="ListaConTocasCiviles.length>0" >
                        <a class="nav-link" id="profile-tab" data-toggle="tab" href="#TocasCiviles" role="tab" aria-controls="TocasCiviles" aria-selected="false">Tocas Civiles ({{ListaConTocasCiviles.length}})</a>
                      </li>
                      <li class="nav-item" v-if="ListaConTocasPenales.length>0" >
                        <a class="nav-link" id="profile-tab" data-toggle="tab" href="#TocasPenales" role="tab" aria-controls="TocasPenales" aria-selected="false">Tocas Penales ({{ListaConTocasPenales.length}})</a>
                      </li>
                      <li class="nav-item" v-if="ListaConTocasOrales.length>0" >
                        <a class="nav-link" id="profile-tab" data-toggle="tab" href="#TocasOrales" role="tab" aria-controls="TocasOrales" aria-selected="false">Tocas Orales ({{ListaConTocasOrales.length}})</a>
                      </li>
                      <li class="nav-item" v-if="ListaConTocasOralADO.length>0" >
                        <a class="nav-link" id="profile-tab" data-toggle="tab" href="#TocasOralADO" role="tab" aria-controls="TocasOralADO" aria-selected="false">Tocas Orales Adolescentes ({{ListaConTocasOralADO.length}})</a>
                      </li>
                      <li class="nav-item" v-if="ListaConTocasOralEJE.length>0" >
                        <a class="nav-link" id="profile-tab" data-toggle="tab" href="#TocasOralEJE" role="tab" aria-controls="TocasOralEJE" aria-selected="false">Tocas Orales Ejecución ({{ListaConTocasOralEJE.length}})</a>
                      </li>
                    </ul>
                    <br>
                  <div class="tab-content" id="myTabContent">
                    <div class="tab-pane fade show active" id="Expedientes" role="tabpanel" aria-labelledby="home-tab" v-if="ListaConFormatoExpedientes.length>0">
                        <div >
                          <h6>Listado de Expedientes Principales , total : {{this.ListaConFormatoExpedientes.length}}</h6>
                        </div>
                        <div id="recepcion_tablePrincipal" class="table-reponsive">
                        <table class="table table-striped table-light table-bordered table-sm">
                            <thead class="thead-dark">
                                <tr>
                                  <th></th>
                                  <th>Documento</th>
                                  <th>Sede</th>
                                  <th>Fecha de Envio</th>
                                  <!-- <th>Contenido</th> -->
                                  <th>Anexos</th>
                                  <th class="text-center"> - </th>
                                </tr>
                            </thead>
                            <tbody class="text-dark" v-for="Lista in ListaConFormatoExpedientes" :key="Lista.InventarioDocumentoId">
                                  <tr>
                                    <td width="20" class="category_enabled text-center">
                                        <input v-model="ARecibir" v-bind:value="Lista.InventarioDocumentoId" type="checkbox" @click="ChecaRecepcion($event, Lista.InventarioDocumentoId)" />
                                    </td>
                                    <td width="250">{{Lista.TipoDocumento.Nombre}} {{Lista.Consecutivo}}/{{Lista.Anio}}</td >
                                    <td width="250">{{Lista.SedeArchivo.Nombre}} </td>
                                    <td width="100" v-html="obtenFechaConFormato(Lista.FechaMovimiento)"></td> 
                                    <!-- <td width="150" v-html="DesglosaContenido(Lista.Movimientos)"></td>  -->
                                    <td width="350">{{Lista.Anexos}}</td>
                                    <td width="20" class="category_enabled text-center">
                                      <input v-model="EliminarDeLista" v-bind:value="Lista.InventarioDocumentoId" type="checkbox" @click="ChecaEliminar($event, Lista.InventarioDocumentoId)"/>
                                    </td>

                                </tr>
                            </tbody>
                        </table>
                        <div>
                            <label>Documentos seleccionadas para Recepción :  {{this.ARecibir.length}}</label>
                        </div>
                        <div class="text-right">
                          <button class="btn btn-sm btn-success" @click='Recibir()' v-if="ARecibir.length>0">Recepción de Documentos</button>
                          <button class="btn btn-sm btn-danger" @click='Eliminar()' v-if="EliminarDeLista.length>0">Eliminar de Listado</button>
                        </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="Amparos" role="tabpanel" aria-labelledby="home-tab" v-if="ListaConFormatoAmparos.length>0">
                      <div>
                          <h6>Listado de Cuadernos de Amparos , total : {{this.ListaConFormatoAmparos.length}}</h6>
                      </div>
                      <div id="recepcion_tableAmparos" class="table-reponsive">
                        <table class="table table-striped table-light table-bordered table-sm">
                            <thead class="thead-dark">
                                <tr>
                                  <th></th>
                                  <th>Documento</th>
                                  <th>Sede</th>
                                  <th>Fecha de Envio</th>
                                  <!-- <th>Contenido</th> -->
                                  <th>Anexos</th>
                                  <th class="text-center"> - </th>
                                </tr>
                            </thead>
                            <tbody class="text-dark" v-for="Lista in ListaConFormatoAmparos" :key="Lista.InventarioDocumentoId">
                                  <tr>
                                    <td width="20" class="category_enabled text-center">
                                        <input v-model="ARecibir" v-bind:value="Lista.InventarioDocumentoId" type="checkbox" @click="ChecaRecepcion($event, Lista.InventarioDocumentoId)" />
                                    </td>
                                    <td width="250">{{Lista.TipoDocumento.Nombre}} {{Lista.Consecutivo}}/{{Lista.Anio}}</td >
                                    <td width="250">{{Lista.SedeArchivo.Nombre}} </td>
                                    <td width="100" v-html="obtenFechaConFormato(Lista.FechaMovimiento)"></td> 
                                    <!-- <td width="150" v-html="DesglosaContenido(Lista.Movimientos)"></td>  -->
                                    <td width="350">{{Lista.Anexos}}</td>
                                    <td width="20" class="category_enabled text-center">
                                      <input v-model="EliminarDeLista" v-bind:value="Lista.InventarioDocumentoId" type="checkbox" @click="ChecaEliminar($event, Lista.InventarioDocumentoId)"/>
                                    </td>

                                </tr>
                            </tbody>
                        </table>
                        <div>
                            <label>Documentos seleccionadas para Recepción :  {{this.ARecibir.length}}</label>
                        </div>
                        <div class="text-right">
                          <button class="btn btn-sm btn-success" @click='Recibir()' v-if="ARecibir.length>0">Recepción de Documentos</button>
                          <button class="btn btn-sm btn-danger" @click='Eliminar()' v-if="EliminarDeLista.length>0">Eliminar de Listado</button>
                        </div>
                      </div>
                    </div>
                    <div class="tab-pane fade" id="Exhortos" role="tabpanel" aria-labelledby="home-tab" v-if="ListaConFormatoExhortos.length>0" >
                      <div>
                          <h6>Listado de Cuadernos de Amparos , total : {{this.ListaConFormatoAmparos.length}}</h6>
                      </div>
                      <div id="recepcion_tableExortos" class="table-reponsive">
                        <table class="table table-striped table-light table-bordered table-sm">
                            <thead class="thead-dark">
                                <tr>
                                  <th></th>
                                  <th>Documento</th>
                                  <th>Sede</th>
                                  <th>Fecha de Envio</th>
                                  <!-- <th>Contenido</th> -->
                                  <th>Anexos</th>
                                  <th class="text-center"> - </th>
                                </tr>
                            </thead>
                            <tbody class="text-dark" v-for="Lista in ListaConFormatoExhortos" :key="Lista.InventarioDocumentoId">
                                  <tr>
                                    <td width="20" class="category_enabled text-center">
                                        <input v-model="ARecibir" v-bind:value="Lista.InventarioDocumentoId" type="checkbox" @click="ChecaRecepcion($event, Lista.InventarioDocumentoId)" />
                                    </td>
                                    <td width="250">{{Lista.TipoDocumento.Nombre}} {{Lista.Consecutivo}}/{{Lista.Anio}}</td >
                                    <td width="250">{{Lista.SedeArchivo.Nombre}} </td>
                                    <td width="100" v-html="obtenFechaConFormato(Lista.FechaMovimiento)"></td> 
                                    <!-- <td width="150" v-html="DesglosaContenido(Lista.Movimientos)"></td>  -->
                                    <td width="350">{{Lista.Anexos}}</td>
                                    <td width="20" class="category_enabled text-center">
                                      <input v-model="EliminarDeLista" v-bind:value="Lista.InventarioDocumentoId" type="checkbox" @click="ChecaEliminar($event, Lista.InventarioDocumentoId)"/>
                                    </td>

                                </tr>
                            </tbody>
                        </table>
                        <div>
                            <label>Documentos seleccionadas para Recepción :  {{this.ARecibir.length}}</label>
                        </div>
                        <div class="text-right">
                          <button class="btn btn-sm btn-success" @click='Recibir()' v-if="ARecibir.length>0">Recepción de Documentos</button>
                          <button class="btn btn-sm btn-danger" @click='Eliminar()' v-if="EliminarDeLista.length>0">Eliminar de Listado</button>
                        </div>
                      </div>
                    </div>
                    <div class="tab-pane fade" id="ExpedientesPenales" role="tabpanel" aria-labelledby="home-tab" v-if="ListaConFormatoExpedientesPenales.length>0" >
                      <div>
                          <h6>Listado de Expedientes Penales , total : {{this.ListaConFormatoExpedientesPenales.length}}</h6>
                      </div>
                      <div id="recepcion_tableExpPenales" class="table-reponsive">
                        <table class="table table-striped table-light table-bordered table-sm">
                            <thead class="thead-dark">
                                <tr>
                                  <th></th>
                                  <th>Documento</th>
                                  <th>Sede</th>
                                  <th>Fecha de Envio</th>
                                  <!-- <th>Contenido</th> -->
                                  <th>Anexos</th>
                                  <th class="text-center"> - </th>
                                </tr>
                            </thead>
                            <tbody class="text-dark" v-for="Lista in ListaConFormatoExpedientesPenales" :key="Lista.InventarioDocumentoId">
                                  <tr>
                                    <td width="20" class="category_enabled text-center">
                                        <input v-model="ARecibir" v-bind:value="Lista.InventarioDocumentoId" type="checkbox" @click="ChecaRecepcion($event, Lista.InventarioDocumentoId)" />
                                    </td>
                                    <td width="250">EXPEDIENTE PENAL {{Lista.Consecutivo}}/{{Lista.Anio}}{{Lista.Sufijo!=null?('-' + Lista.Sufijo) : ''}}</td >
                                    <td width="250">{{Lista.SedeArchivo.Nombre}} </td>
                                    <td width="100" v-html="obtenFechaConFormato(Lista.FechaMovimiento)"></td> 
                                    <!-- <td width="150" v-html="DesglosaContenido(Lista.Movimientos)"></td>  -->
                                    <td width="350">{{Lista.Anexos}}</td>
                                    <td width="20" class="category_enabled text-center">
                                      <input v-model="EliminarDeLista" v-bind:value="Lista.InventarioDocumentoId" type="checkbox" @click="ChecaEliminar($event, Lista.InventarioDocumentoId)"/>
                                    </td>

                                </tr>
                            </tbody>
                        </table>
                        <div>
                            <label>Documentos seleccionadas para Recepción :  {{this.ARecibir.length}}</label>
                        </div>
                        <div class="text-right">
                          <button class="btn btn-sm btn-success" @click='Recibir()' v-if="ARecibir.length>0">Recepción de Documentos</button>
                          <button class="btn btn-sm btn-danger" @click='Eliminar()' v-if="EliminarDeLista.length>0">Eliminar de Listado</button>
                        </div>
                      </div>
                    </div>
                    <div class="tab-pane fade" id="Digitales" role="tabpanel" aria-labelledby="home-tab" v-if="ListaConDigitales.length>0" >
                        <div >
                          <h6>Listado de Carpetas Digitales , total : {{this.ListaConDigitales.length}}</h6>
                        </div>
                        <div id="recepcion_tableDigitales" class="table-reponsive">
                        <table class="table table-striped table-light table-bordered table-sm">
                            <thead class="thead-dark">
                                <tr>
                                  <th></th>
                                  <th>Documento</th>
                                  <th>Sede</th>
                                  <th>Fecha de Envio</th>
                                  <!-- <th>Contenido</th> -->
                                  <th>Anexos</th>
                                  <th class="text-center"> - </th>
                                </tr>
                            </thead>
                            <tbody class="text-dark" v-for="Lista in ListaConDigitales" :key="Lista.InventarioDocumentoId">
                                  <tr>
                                    <td width="20" class="category_enabled text-center">
                                        <input v-model="ARecibir" v-bind:value="Lista.InventarioDocumentoId" type="checkbox" @click="ChecaRecepcion($event, Lista.InventarioDocumentoId)" />
                                    </td>
                                    <td width="250">{{Lista.TipoDocumento.Nombre}} {{Lista.Consecutivo}}/{{Lista.Anio}}{{Lista.Sufijo!=null?('-' + Lista.Sufijo) : ''}}</td >
                                    <td width="250">{{Lista.SedeArchivo.Nombre}} </td>
                                    <td width="100" v-html="obtenFechaConFormato(Lista.FechaMovimiento)"></td> 
                                    <!-- <td width="150" v-html="DesglosaContenido(Lista.Movimientos)"></td>  -->
                                    <td width="350">{{Lista.Anexos}}</td>
                                    <td width="20" class="category_enabled text-center">
                                      <input v-model="EliminarDeLista" v-bind:value="Lista.InventarioDocumentoId" type="checkbox" @click="ChecaEliminar($event, Lista.InventarioDocumentoId)"/>
                                    </td>

                                </tr>
                            </tbody>
                        </table>
                        <div>
                            <label>Documentos seleccionadas para Recepción :  {{this.ARecibir.length}}</label>
                        </div>
                        <div class="text-right">
                          <button class="btn btn-sm btn-success" @click='Recibir()' v-if="ARecibir.length>0">Recepción de Documentos</button>
                          <button class="btn btn-sm btn-danger" @click='Eliminar()' v-if="EliminarDeLista.length>0">Eliminar de Listado</button>
                        </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="Administrativas" role="tabpanel" aria-labelledby="home-tab" v-if="ListaConAdministrativas.length>0">
                        <div >
                          <h6>Listado de Carpetas Administrativas , total : {{this.ListaConAdministrativas.length}}</h6>
                        </div>
                        <div id="recepcion_tableadministrativas" class="table-reponsive">
                        <table class="table table-striped table-light table-bordered table-sm">
                            <thead class="thead-dark">
                                <tr>
                                  <th></th>
                                  <th>Documento</th>
                                  <th>Sede</th>
                                  <th>Fecha de Envio</th>
                                  <!-- <th>Contenido</th> -->
                                  <th>Anexos</th>
                                  <th class="text-center"> - </th>
                                </tr>
                            </thead>
                            <tbody class="text-dark" v-for="Lista in ListaConAdministrativas" :key="Lista.InventarioDocumentoId">
                                  <tr>
                                    <td width="20" class="category_enabled text-center">
                                        <input v-model="ARecibir" v-bind:value="Lista.InventarioDocumentoId" type="checkbox" @click="ChecaRecepcion($event, Lista.InventarioDocumentoId)" />
                                    </td>
                                    <td width="250">{{Lista.TipoDocumento.Nombre}} {{Lista.Consecutivo}}/{{Lista.Anio}}{{Lista.Sufijo!=null?('-' + Lista.Sufijo) : ''}}</td >
                                    <td width="250">{{Lista.SedeArchivo.Nombre}} </td>
                                    <td width="100" v-html="obtenFechaConFormato(Lista.FechaMovimiento)"></td> 
                                    <!-- <td width="150" v-html="DesglosaContenido(Lista.Movimientos)"></td>  -->
                                    <td width="350">{{Lista.Anexos}}</td>
                                    <td width="20" class="category_enabled text-center">
                                      <input v-model="EliminarDeLista" v-bind:value="Lista.InventarioDocumentoId" type="checkbox" @click="ChecaEliminar($event, Lista.InventarioDocumentoId)"/>
                                    </td>

                                </tr>
                            </tbody>
                        </table>
                        <div>
                            <label>Documentos seleccionadas para Recepción :  {{this.ARecibir.length}}</label>
                        </div>
                        <div class="text-right">
                          <button class="btn btn-sm btn-success" @click='Recibir()' v-if="ARecibir.length>0">Recepción de Documentos</button>
                          <button class="btn btn-sm btn-danger" @click='Eliminar()' v-if="EliminarDeLista.length>0">Eliminar de Listado</button>
                        </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="AmparosPenales" role="tabpanel" aria-labelledby="home-tab" v-if="ListaConFormatoAmparosPenales.length>0" >
                      <div>
                          <h6>Listado de Amparos Penales , total : {{this.ListaConFormatoAmparosPenales.length}}</h6>
                      </div>
                      <div id="recepcion_tableAmparosPenales" class="table-reponsive">
                        <table class="table table-striped table-light table-bordered table-sm">
                            <thead class="thead-dark">
                                <tr>
                                  <th></th>
                                  <th>Documento</th>
                                  <th>Sede</th>
                                  <th>Fecha de Envio</th>
                                  <!-- <th>Contenido</th> -->
                                  <th>Anexos</th>
                                  <th class="text-center"> - </th>
                                </tr>
                            </thead>
                            <tbody class="text-dark" v-for="Lista in ListaConFormatoAmparosPenales" :key="Lista.InventarioDocumentoId">
                                  <tr>
                                    <td width="20" class="category_enabled text-center">
                                        <input v-model="ARecibir" v-bind:value="Lista.InventarioDocumentoId" type="checkbox" @click="ChecaRecepcion($event, Lista.InventarioDocumentoId)" />
                                    </td>
                                    <td width="250">AMPARO PENAL {{Lista.Consecutivo}}/{{Lista.Anio}}</td >
                                    <td width="250">{{Lista.SedeArchivo.Nombre}} </td>
                                    <td width="100" v-html="obtenFechaConFormato(Lista.FechaMovimiento)"></td> 
                                    <!-- <td width="150" v-html="DesglosaContenido(Lista.Movimientos)"></td>  -->
                                    <td width="350">{{Lista.Anexos}}</td>
                                    <td width="20" class="category_enabled text-center">
                                      <input v-model="EliminarDeLista" v-bind:value="Lista.InventarioDocumentoId" type="checkbox" @click="ChecaEliminar($event, Lista.InventarioDocumentoId)"/>
                                    </td>

                                </tr>
                            </tbody>
                        </table>
                        <div>
                            <label>Documentos seleccionadas para Recepción :  {{this.ARecibir.length}}</label>
                        </div>
                        <div class="text-right">
                          <button class="btn btn-sm btn-success" @click='Recibir()' v-if="ARecibir.length>0">Recepción de Documentos</button>
                          <button class="btn btn-sm btn-danger" @click='Eliminar()' v-if="EliminarDeLista.length>0">Eliminar de Listado</button>
                        </div>
                      </div>
                    </div>
                    <div class="tab-pane fade" id="ExhortosPenales" role="tabpanel" aria-labelledby="home-tab" v-if="ListaConFormatoExhortosPenales.length>0" >
                      <div>
                          <h6>Listado de Exhortos Penales , total : {{this.ListaConFormatoExhortosPenales.length}}</h6>
                      </div>
                      <div id="recepcion_tableExhortosPenales" class="table-reponsive">
                        <table class="table table-striped table-light table-bordered table-sm">
                            <thead class="thead-dark">
                                <tr>
                                  <th></th>
                                  <th>Documento</th>
                                  <th>Sede</th>
                                  <th>Fecha de Envio</th>
                                  <!-- <th>Contenido</th> -->
                                  <th>Anexos</th>
                                  <th class="text-center"> - </th>
                                </tr>
                            </thead>
                            <tbody class="text-dark" v-for="Lista in ListaConFormatoExhortosPenales" :key="Lista.InventarioDocumentoId">
                                  <tr>
                                    <td width="20" class="category_enabled text-center">
                                        <input v-model="ARecibir" v-bind:value="Lista.InventarioDocumentoId" type="checkbox" @click="ChecaRecepcion($event, Lista.InventarioDocumentoId)" />
                                    </td>
                                    <td width="250">EXHORTO PENAL {{Lista.Consecutivo}}/{{Lista.Anio}}</td >
                                    <td width="250">{{Lista.SedeArchivo.Nombre}} </td>
                                    <td width="100" v-html="obtenFechaConFormato(Lista.FechaMovimiento)"></td> 
                                    <!-- <td width="150" v-html="DesglosaContenido(Lista.Movimientos)"></td>  -->
                                    <td width="350">{{Lista.Anexos}}</td>
                                    <td width="20" class="category_enabled text-center">
                                      <input v-model="EliminarDeLista" v-bind:value="Lista.InventarioDocumentoId" type="checkbox" @click="ChecaEliminar($event, Lista.InventarioDocumentoId)"/>
                                    </td>

                                </tr>
                            </tbody>
                        </table>
                        <div>
                            <label>Documentos seleccionadas para Recepción :  {{this.ARecibir.length}}</label>
                        </div>
                        <div class="text-right">
                          <button class="btn btn-sm btn-success" @click='Recibir()' v-if="ARecibir.length>0">Recepción de Documentos</button>
                          <button class="btn btn-sm btn-danger" @click='Eliminar()' v-if="EliminarDeLista.length>0">Eliminar de Listado</button>
                        </div>
                      </div>
                    </div>
                    <div class="tab-pane fade" id="TocasCiviles" role="tabpanel" aria-labelledby="home-tab" v-if="ListaConTocasCiviles.length>0" >
                      <div>
                          <h6>Listado de Tocas Civiles , total : {{this.ListaConTocasCiviles.length}}</h6>
                      </div>
                      <div id="recepcion_tableTocasCiviles" class="table-reponsive">
                        <table class="table table-striped table-light table-bordered table-sm">
                            <thead class="thead-dark">
                                <tr>
                                  <th></th>
                                  <th>Documento</th>
                                  <th>Sede</th>
                                  <th>Fecha de Envio</th>
                                  <!-- <th>Contenido</th> -->
                                  <th>Anexos</th>
                                  <th class="text-center"> - </th>
                                </tr>
                            </thead>
                            <tbody class="text-dark" v-for="Lista in ListaConTocasCiviles" :key="Lista.InventarioDocumentoId">
                                  <tr>
                                    <td width="20" class="category_enabled text-center">
                                        <input v-model="ARecibir" v-bind:value="Lista.InventarioDocumentoId" type="checkbox" @click="ChecaRecepcion($event, Lista.InventarioDocumentoId)" />
                                    </td>
                                    <td width="250">TOCA CIVIL {{Lista.Consecutivo}}/{{Lista.Anio}}</td >
                                    <td width="250">{{Lista.SedeArchivo.Nombre}} </td>
                                    <td width="100" v-html="obtenFechaConFormato(Lista.FechaMovimiento)"></td> 
                                    <!-- <td width="150" v-html="DesglosaContenido(Lista.Movimientos)"></td>  -->
                                    <td width="350">{{Lista.Anexos}}</td>
                                    <td width="20" class="category_enabled text-center">
                                      <input v-model="EliminarDeLista" v-bind:value="Lista.InventarioDocumentoId" type="checkbox" @click="ChecaEliminar($event, Lista.InventarioDocumentoId)"/>
                                    </td>

                                </tr>
                            </tbody>
                        </table>
                        <div>
                            <label>Documentos seleccionadas para Recepción :  {{this.ARecibir.length}}</label>
                        </div>
                        <div class="text-right">
                          <button class="btn btn-sm btn-success" @click='Recibir()' v-if="ARecibir.length>0">Recepción de Documentos</button>
                          <button class="btn btn-sm btn-danger" @click='Eliminar()' v-if="EliminarDeLista.length>0">Eliminar de Listado</button>
                        </div>
                      </div>
                    </div>
                    <div class="tab-pane fade" id="TocasPenales" role="tabpanel" aria-labelledby="home-tab" v-if="ListaConTocasPenales.length>0" >
                      <div>
                          <h6>Listado de Tocas Penales , total : {{this.ListaConTocasPenales.length}}</h6>
                      </div>
                      <div id="recepcion_tableTocasPenales" class="table-reponsive">
                        <table class="table table-striped table-light table-bordered table-sm">
                            <thead class="thead-dark">
                                <tr>
                                  <th></th>
                                  <th>Documento</th>
                                  <th>Sede</th>
                                  <th>Fecha de Envio</th>
                                  <!-- <th>Contenido</th> -->
                                  <th>Anexos</th>
                                  <th class="text-center"> - </th>
                                </tr>
                            </thead>
                            <tbody class="text-dark" v-for="Lista in ListaConTocasPenales" :key="Lista.InventarioDocumentoId">
                                  <tr>
                                    <td width="20" class="category_enabled text-center">
                                        <input v-model="ARecibir" v-bind:value="Lista.InventarioDocumentoId" type="checkbox" @click="ChecaRecepcion($event, Lista.InventarioDocumentoId)" />
                                    </td>
                                    <td width="250">TOCA PENAL {{Lista.Consecutivo}}/{{Lista.Anio}}</td >
                                    <td width="250">{{Lista.SedeArchivo.Nombre}} </td>
                                    <td width="100" v-html="obtenFechaConFormato(Lista.FechaMovimiento)"></td> 
                                    <!-- <td width="150" v-html="DesglosaContenido(Lista.Movimientos)"></td>  -->
                                    <td width="350">{{Lista.Anexos}}</td>
                                    <td width="20" class="category_enabled text-center">
                                      <input v-model="EliminarDeLista" v-bind:value="Lista.InventarioDocumentoId" type="checkbox" @click="ChecaEliminar($event, Lista.InventarioDocumentoId)"/>
                                    </td>

                                </tr>
                            </tbody>
                        </table>
                        <div>
                            <label>Documentos seleccionadas para Recepción :  {{this.ARecibir.length}}</label>
                        </div>
                        <div class="text-right">
                          <button class="btn btn-sm btn-success" @click='Recibir()' v-if="ARecibir.length>0">Recepción de Documentos</button>
                          <button class="btn btn-sm btn-danger" @click='Eliminar()' v-if="EliminarDeLista.length>0">Eliminar de Listado</button>
                        </div>
                      </div>
                    </div>
                    <div class="tab-pane fade" id="TocasOrales" role="tabpanel" aria-labelledby="home-tab" v-if="ListaConTocasOrales.length>0" >
                      <div>
                          <h6>Listado de Tocas Penales , total : {{this.ListaConTocasOrales.length}}</h6>
                      </div>
                      <div id="recepcion_tableTocasOrales" class="table-reponsive">
                        <table class="table table-striped table-light table-bordered table-sm">
                            <thead class="thead-dark">
                                <tr>
                                  <th></th>
                                  <th>Documento</th>
                                  <th>Sede</th>
                                  <th>Fecha de Envio</th>
                                  <!-- <th>Contenido</th> -->
                                  <th>Anexos</th>
                                  <th class="text-center"> - </th>
                                </tr>
                            </thead>
                            <tbody class="text-dark" v-for="Lista in ListaConTocasOrales" :key="Lista.InventarioDocumentoId">
                                  <tr>
                                    <td width="20" class="category_enabled text-center">
                                        <input v-model="ARecibir" v-bind:value="Lista.InventarioDocumentoId" type="checkbox" @click="ChecaRecepcion($event, Lista.InventarioDocumentoId)" />
                                    </td>
                                    <td width="250">TOCA ORAL {{Lista.Consecutivo}}/{{Lista.Anio}}</td >
                                    <td width="250">{{Lista.SedeArchivo.Nombre}} </td>
                                    <td width="100" v-html="obtenFechaConFormato(Lista.FechaMovimiento)"></td> 
                                    <!-- <td width="150" v-html="DesglosaContenido(Lista.Movimientos)"></td>  -->
                                    <td width="350">{{Lista.Anexos!=null ? Lista.Anexos : ''}}</td>
                                    <td width="20" class="category_enabled text-center">
                                      <input v-model="EliminarDeLista" v-bind:value="Lista.InventarioDocumentoId" type="checkbox" @click="ChecaEliminar($event, Lista.InventarioDocumentoId)"/>
                                    </td>

                                </tr>
                            </tbody>
                        </table>
                        <div>
                            <label>Documentos seleccionadas para Recepción :  {{this.ARecibir.length}}</label>
                        </div>
                        <div class="text-right">
                          <button class="btn btn-sm btn-success" @click='Recibir()' v-if="ARecibir.length>0">Recepción de Documentos</button>
                          <button class="btn btn-sm btn-danger" @click='Eliminar()' v-if="EliminarDeLista.length>0">Eliminar de Listado</button>
                        </div>
                      </div>
                    </div>
                    <div class="tab-pane fade" id="TocasOralADO" role="tabpanel" aria-labelledby="home-tab" v-if="ListaConTocasOralADO.length>0" >
                      <div>
                          <h6>Listado de Tocas Penales , total : {{this.ListaConTocasOralADO.length}}</h6>
                      </div>
                      <div id="recepcion_tableTocasOralADO" class="table-reponsive">
                        <table class="table table-striped table-light table-bordered table-sm">
                            <thead class="thead-dark">
                                <tr>
                                  <th></th>
                                  <th>Documento</th>
                                  <th>Sede</th>
                                  <th>Fecha de Envio</th>
                                  <!-- <th>Contenido</th> -->
                                  <th>Anexos</th>
                                  <th class="text-center"> - </th>
                                </tr>
                            </thead>
                            <tbody class="text-dark" v-for="Lista in ListaConTocasOralADO" :key="Lista.InventarioDocumentoId">
                                  <tr>
                                    <td width="20" class="category_enabled text-center">
                                        <input v-model="ARecibir" v-bind:value="Lista.InventarioDocumentoId" type="checkbox" @click="ChecaRecepcion($event, Lista.InventarioDocumentoId)" />
                                    </td>
                                    <td width="250">TOCA ORAL ADOLESCENTES {{Lista.Consecutivo}}/{{Lista.Anio}}</td >
                                    <td width="250">{{Lista.SedeArchivo.Nombre}} </td>
                                    <td width="100" v-html="obtenFechaConFormato(Lista.FechaMovimiento)"></td> 
                                    <!-- <td width="150" v-html="DesglosaContenido(Lista.Movimientos)"></td>  -->
                                    <td width="350">{{Lista.Anexos!=null ? Lista.Anexos : ''}}</td>
                                    <td width="20" class="category_enabled text-center">
                                      <input v-model="EliminarDeLista" v-bind:value="Lista.InventarioDocumentoId" type="checkbox" @click="ChecaEliminar($event, Lista.InventarioDocumentoId)"/>
                                    </td>

                                </tr>
                            </tbody>
                        </table>
                        <div>
                            <label>Documentos seleccionadas para Recepción :  {{this.ARecibir.length}}</label>
                        </div>
                        <div class="text-right">
                          <button class="btn btn-sm btn-success" @click='Recibir()' v-if="ARecibir.length>0">Recepción de Documentos</button>
                          <button class="btn btn-sm btn-danger" @click='Eliminar()' v-if="EliminarDeLista.length>0">Eliminar de Listado</button>
                        </div>
                      </div>
                    </div>
                    <div class="tab-pane fade" id="TocasOralEJE" role="tabpanel" aria-labelledby="home-tab" v-if="ListaConTocasOralEJE.length>0" >
                      <div>
                          <h6>Listado de Tocas Penales , total : {{this.ListaConTocasOralEJE.length}}</h6>
                      </div>
                      <div id="recepcion_tableTocasOralEJE" class="table-reponsive">
                        <table class="table table-striped table-light table-bordered table-sm">
                            <thead class="thead-dark">
                                <tr>
                                  <th></th>
                                  <th>Documento</th>
                                  <th>Sede</th>
                                  <th>Fecha de Envio</th>
                                  <!-- <th>Contenido</th> -->
                                  <th>Anexos</th>
                                  <th class="text-center"> - </th>
                                </tr>
                            </thead>
                            <tbody class="text-dark" v-for="Lista in ListaConTocasOralEJE" :key="Lista.InventarioDocumentoId">
                                  <tr>
                                    <td width="20" class="category_enabled text-center">
                                        <input v-model="ARecibir" v-bind:value="Lista.InventarioDocumentoId" type="checkbox" @click="ChecaRecepcion($event, Lista.InventarioDocumentoId)" />
                                    </td>
                                    <td width="250">TOCA ORAL EJECUCIÓN {{Lista.Consecutivo}}/{{Lista.Anio}}</td >
                                    <td width="250">{{Lista.SedeArchivo.Nombre}} </td>
                                    <td width="100" v-html="obtenFechaConFormato(Lista.FechaMovimiento)"></td> 
                                    <!-- <td width="150" v-html="DesglosaContenido(Lista.Movimientos)"></td>  -->
                                    <td width="350">{{Lista.Anexos!=null ? Lista.Anexos : ''}}</td>
                                    <td width="20" class="category_enabled text-center">
                                      <input v-model="EliminarDeLista" v-bind:value="Lista.InventarioDocumentoId" type="checkbox" @click="ChecaEliminar($event, Lista.InventarioDocumentoId)"/>
                                    </td>

                                </tr>
                            </tbody>
                        </table>
                        <div>
                            <label>Documentos seleccionadas para Recepción :  {{this.ARecibir.length}}</label>
                        </div>
                        <div class="text-right">
                          <button class="btn btn-sm btn-success" @click='Recibir()' v-if="ARecibir.length>0">Recepción de Documentos</button>
                          <button class="btn btn-sm btn-danger" @click='Eliminar()' v-if="EliminarDeLista.length>0">Eliminar de Listado</button>
                        </div>
                      </div>
                    </div>
                  </div>
              </div>
              <div v-else>
                  <ul class="nav nav-tabs" id="myTab" role="tablist">
                      <li class="nav-item" >
                        <a class="nav-link active" id="home-tab" data-toggle="tab" href="#Digitales" role="tab" aria-controls="Digitales" aria-selected="true">Carpetas Digitales ({{ListaConDigitales.length}})</a>
                      </li>
                      <li class="nav-item" >
                        <a class="nav-link" id="profile-tab" data-toggle="tab" href="#Administrativas" role="tab" aria-controls="Administrativas" aria-selected="false">Carpetas Administrativas ({{ListaConAdministrativas.length}})</a>
                      </li>
                      <li class="nav-item" >
                        <a class="nav-link" id="profile-tab" data-toggle="tab" href="#Ejecucion" role="tab" aria-controls="Ejecucion" aria-selected="false">Carpetas de Ejecución ({{ListaConEjecucion.length}})</a>
                      </li>
                      <li class="nav-item" >
                        <a class="nav-link" id="profile-tab" data-toggle="tab" href="#Juicio" role="tab" aria-controls="Juicio" aria-selected="false">Carpetas de Jucioc ({{ListaConJuicio.length}})</a>
                      </li>
                      <li class="nav-item" >
                        <a class="nav-link" id="profile-tab" data-toggle="tab" href="#Amparos" role="tab" aria-controls="Amparos" aria-selected="false">Cuadernos de Amparo ({{ListaConFormatoAmparos.length}})</a>
                      </li>
                      <li class="nav-item" >
                        <a class="nav-link" id="profile-tab" data-toggle="tab" href="#Exhortos" role="tab" aria-controls="Exhortos" aria-selected="false">Exhortos ({{ListaConFormatoExhortos.length}})</a>
                      </li>
                    </ul>
                    <div class="tab-content" id="myTabContent">
                    <div class="tab-pane fade show active" id="Digitales" role="tabpanel" aria-labelledby="home-tab" >
                        <div >
                          <h6>Listado de Carpetas Digitales , total : {{this.ListaConDigitales.length}}</h6>
                        </div>
                        <div id="recepcion_tableDigitales" class="table-reponsive">
                        <table class="table table-striped table-light table-bordered table-sm">
                            <thead class="thead-dark">
                                <tr>
                                  <th></th>
                                  <th>Documento</th>
                                  <th>Sede</th>
                                  <th>Fecha de Envio</th>
                                  <!-- <th>Contenido</th> -->
                                  <th>Anexos</th>
                                  <th class="text-center"> - </th>
                                </tr>
                            </thead>
                            <tbody class="text-dark" v-for="Lista in ListaConDigitales" :key="Lista.InventarioDocumentoId">
                                  <tr>
                                    <td width="20" class="category_enabled text-center">
                                        <input v-model="ARecibir" v-bind:value="Lista.InventarioDocumentoId" type="checkbox" @click="ChecaRecepcion($event, Lista.InventarioDocumentoId)" />
                                    </td>
                                    <td width="250">{{Lista.TipoDocumento.Nombre}} {{Lista.Consecutivo}}/{{Lista.Anio}}</td >
                                    <td width="250">{{Lista.SedeArchivo.Nombre}} </td>
                                    <td width="100" v-html="obtenFechaConFormato(Lista.FechaMovimiento)"></td> 
                                    <!-- <td width="150" v-html="DesglosaContenido(Lista.Movimientos)"></td>  -->
                                    <td width="350">{{Lista.Anexos}}</td>
                                    <td width="20" class="category_enabled text-center">
                                      <input v-model="EliminarDeLista" v-bind:value="Lista.InventarioDocumentoId" type="checkbox" @click="ChecaEliminar($event, Lista.InventarioDocumentoId)"/>
                                    </td>

                                </tr>
                            </tbody>
                        </table>
                        <div>
                            <label>Documentos seleccionadas para Recepción :  {{this.ARecibir.length}}</label>
                        </div>
                        <div class="text-right">
                          <button class="btn btn-sm btn-success" @click='Recibir()' v-if="ARecibir.length>0">Recepción de Documentos</button>
                          <button class="btn btn-sm btn-danger" @click='Eliminar()' v-if="EliminarDeLista.length>0">Eliminar de Listado</button>
                        </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="Administrativas" role="tabpanel" aria-labelledby="home-tab" >
                        <div >
                          <h6>Listado de Carpetas Administrativas , total : {{this.ListaConAdministrativas.length}}</h6>
                        </div>
                        <div id="recepcion_tableadministrativas" class="table-reponsive">
                        <table class="table table-striped table-light table-bordered table-sm">
                            <thead class="thead-dark">
                                <tr>
                                  <th></th>
                                  <th>Documento</th>
                                  <th>Sede</th>
                                  <th>Fecha de Envio</th>
                                  <!-- <th>Contenido</th> -->
                                  <th>Anexos</th>
                                  <th class="text-center"> - </th>
                                </tr>
                            </thead>
                            <tbody class="text-dark" v-for="Lista in ListaConAdministrativas" :key="Lista.InventarioDocumentoId">
                                  <tr>
                                    <td width="20" class="category_enabled text-center">
                                        <input v-model="ARecibir" v-bind:value="Lista.InventarioDocumentoId" type="checkbox" @click="ChecaRecepcion($event, Lista.InventarioDocumentoId)" />
                                    </td>
                                    <td width="250">{{Lista.TipoDocumento.Nombre}} {{Lista.Consecutivo}}/{{Lista.Anio}}</td >
                                    <td width="250">{{Lista.SedeArchivo.Nombre}} </td>
                                    <td width="100" v-html="obtenFechaConFormato(Lista.FechaMovimiento)"></td> 
                                    <!-- <td width="150" v-html="DesglosaContenido(Lista.Movimientos)"></td>  -->
                                    <td width="350">{{Lista.Anexos}}</td>
                                    <td width="20" class="category_enabled text-center">
                                      <input v-model="EliminarDeLista" v-bind:value="Lista.InventarioDocumentoId" type="checkbox" @click="ChecaEliminar($event, Lista.InventarioDocumentoId)"/>
                                    </td>

                                </tr>
                            </tbody>
                        </table>
                        <div>
                            <label>Documentos seleccionadas para Recepción :  {{this.ARecibir.length}}</label>
                        </div>
                        <div class="text-right">
                          <button class="btn btn-sm btn-success" @click='Recibir()' v-if="ARecibir.length>0">Recepción de Documentos</button>
                          <button class="btn btn-sm btn-danger" @click='Eliminar()' v-if="EliminarDeLista.length>0">Eliminar de Listado</button>
                        </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="Ejecucion" role="tabpanel" aria-labelledby="home-tab" >
                        <div >
                          <h6>Listado de Carpetas de Ejecucióm , total : {{this.ListaConEjecucion.length}}</h6>
                        </div>
                        <div id="recepcion_tableEjecucion" class="table-reponsive">
                        <table class="table table-striped table-light table-bordered table-sm">
                            <thead class="thead-dark">
                                <tr>
                                  <th></th>
                                  <th>Documento</th>
                                  <th>Sede</th>
                                  <th>Fecha de Envio</th>
                                  <!-- <th>Contenido</th> -->
                                  <th>Anexos</th>
                                  <th class="text-center"> - </th>
                                </tr>
                            </thead>
                            <tbody class="text-dark" v-for="Lista in ListaConEjecucion" :key="Lista.InventarioDocumentoId">
                                  <tr>
                                    <td width="20" class="category_enabled text-center">
                                        <input v-model="ARecibir" v-bind:value="Lista.InventarioDocumentoId" type="checkbox" @click="ChecaRecepcion($event, Lista.InventarioDocumentoId)" />
                                    </td>
                                    <td width="250">{{Lista.TipoDocumento.Nombre}} {{Lista.Consecutivo}}/{{Lista.Anio}}</td >
                                    <td width="250">{{Lista.SedeArchivo.Nombre}} </td>
                                    <td width="100" v-html="obtenFechaConFormato(Lista.FechaMovimiento)"></td> 
                                    <!-- <td width="150" v-html="DesglosaContenido(Lista.Movimientos)"></td>  -->
                                    <td width="350">{{Lista.Anexos}}</td>
                                    <td width="20" class="category_enabled text-center">
                                      <input v-model="EliminarDeLista" v-bind:value="Lista.InventarioDocumentoId" type="checkbox" @click="ChecaEliminar($event, Lista.InventarioDocumentoId)"/>
                                    </td>

                                </tr>
                            </tbody>
                        </table>
                        <div>
                            <label>Documentos seleccionadas para Recepción :  {{this.ARecibir.length}}</label>
                        </div>
                        <div class="text-right">
                          <button class="btn btn-sm btn-success" @click='Recibir()' v-if="ARecibir.length>0">Recepción de Documentos</button>
                          <button class="btn btn-sm btn-danger" @click='Eliminar()' v-if="EliminarDeLista.length>0">Eliminar de Listado</button>
                        </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="Juicio" role="tabpanel" aria-labelledby="home-tab" >
                        <div >
                          <h6>Listado de Carpetas de Juicio , total : {{this.ListaConJuicio.length}}</h6>
                        </div>
                        <div id="recepcion_tableJuicio" class="table-reponsive">
                        <table class="table table-striped table-light table-bordered table-sm">
                            <thead class="thead-dark">
                                <tr>
                                  <th></th>
                                  <th>Documento</th>
                                  <th>Sede</th>
                                  <th>Fecha de Envio</th>
                                  <!-- <th>Contenido</th> -->
                                  <th>Anexos</th>
                                  <th class="text-center"> - </th>
                                </tr>
                            </thead>
                            <tbody class="text-dark" v-for="Lista in ListaConJuicio" :key="Lista.InventarioDocumentoId">
                                  <tr>
                                    <td width="20" class="category_enabled text-center">
                                        <input v-model="ARecibir" v-bind:value="Lista.InventarioDocumentoId" type="checkbox" @click="ChecaRecepcion($event, Lista.InventarioDocumentoId)" />
                                    </td>
                                    <td width="250">{{Lista.TipoDocumento.Nombre}} {{Lista.Consecutivo}}/{{Lista.Anio}}</td >
                                    <td width="250">{{Lista.SedeArchivo.Nombre}} </td>
                                    <td width="100" v-html="obtenFechaConFormato(Lista.FechaMovimiento)"></td> 
                                    <!-- <td width="150" v-html="DesglosaContenido(Lista.Movimientos)"></td>  -->
                                    <td width="350">{{Lista.Anexos}}</td>
                                    <td width="20" class="category_enabled text-center">
                                      <input v-model="EliminarDeLista" v-bind:value="Lista.InventarioDocumentoId" type="checkbox" @click="ChecaEliminar($event, Lista.InventarioDocumentoId)"/>
                                    </td>

                                </tr>
                            </tbody>
                        </table>
                        <div>
                            <label>Documentos seleccionadas para Recepción :  {{this.ARecibir.length}}</label>
                        </div>
                        <div class="text-right">
                          <button class="btn btn-sm btn-success" @click='Recibir()' v-if="ARecibir.length>0">Recepción de Documentos</button>
                          <button class="btn btn-sm btn-danger" @click='Eliminar()' v-if="EliminarDeLista.length>0">Eliminar de Listado</button>
                        </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="Amparos" role="tabpanel" aria-labelledby="home-tab" >
                      <div>
                          <h6>Listado de Cuadernos de Amparos , total : {{this.ListaConFormatoAmparos.length}}</h6>
                      </div>
                      <div id="recepcion_tableAmparos" class="table-reponsive">
                        <table class="table table-striped table-light table-bordered table-sm">
                            <thead class="thead-dark">
                                <tr>
                                  <th></th>
                                  <th>Documento</th>
                                  <th>Sede</th>
                                  <th>Fecha de Envio</th>
                                  <!-- <th>Contenido</th> -->
                                  <th>Anexos</th>
                                  <th class="text-center"> - </th>
                                </tr>
                            </thead>
                            <tbody class="text-dark" v-for="Lista in ListaConFormatoAmparos" :key="Lista.InventarioDocumentoId">
                                  <tr>
                                    <td width="20" class="category_enabled text-center">
                                        <input v-model="ARecibir" v-bind:value="Lista.InventarioDocumentoId" type="checkbox" @click="ChecaRecepcion($event, Lista.InventarioDocumentoId)" />
                                    </td>
                                    <td width="250">{{Lista.TipoDocumento.Nombre}} {{Lista.Consecutivo}}/{{Lista.Anio}}</td >
                                    <td width="250">{{Lista.SedeArchivo.Nombre}} </td>
                                    <td width="100" v-html="obtenFechaConFormato(Lista.FechaMovimiento)"></td> 
                                    <!-- <td width="150" v-html="DesglosaContenido(Lista.Movimientos)"></td>  -->
                                    <td width="350">{{Lista.Anexos}}</td>
                                    <td width="20" class="category_enabled text-center">
                                      <input v-model="EliminarDeLista" v-bind:value="Lista.InventarioDocumentoId" type="checkbox" @click="ChecaEliminar($event, Lista.InventarioDocumentoId)"/>
                                    </td>

                                </tr>
                            </tbody>
                        </table>
                        <div>
                            <label>Documentos seleccionadas para Recepción :  {{this.ARecibir.length}}</label>
                        </div>
                        <div class="text-right">
                          <button class="btn btn-sm btn-success" @click='Recibir()' v-if="ARecibir.length>0">Recepción de Documentos</button>
                          <button class="btn btn-sm btn-danger" @click='Eliminar()' v-if="EliminarDeLista.length>0">Eliminar de Listado</button>
                        </div>
                      </div>
                    </div>
                    <div class="tab-pane fade" id="Exhortos" role="tabpanel" aria-labelledby="home-tab" >
                      <div>
                          <h6>Listado de Cuadernos de Amparos , total : {{this.ListaConFormatoAmparos.length}}</h6>
                      </div>
                      <div id="recepcion_tableExortos" class="table-reponsive">
                        <table class="table table-striped table-light table-bordered table-sm">
                            <thead class="thead-dark">
                                <tr>
                                  <th></th>
                                  <th>Documento</th>
                                  <th>Sede</th>
                                  <th>Fecha de Envio</th>
                                  <!-- <th>Contenido</th> -->
                                  <th>Anexos</th>
                                  <th class="text-center"> - </th>
                                </tr>
                            </thead>
                            <tbody class="text-dark" v-for="Lista in ListaConFormatoExhortos" :key="Lista.InventarioDocumentoId">
                                  <tr>
                                    <td width="20" class="category_enabled text-center">
                                        <input v-model="ARecibir" v-bind:value="Lista.InventarioDocumentoId" type="checkbox" @click="ChecaRecepcion($event, Lista.InventarioDocumentoId)" />
                                    </td>
                                    <td width="250">{{Lista.TipoDocumento.Nombre}} {{Lista.Consecutivo}}/{{Lista.Anio}}</td >
                                    <td width="250">{{Lista.SedeArchivo.Nombre}} </td>
                                    <td width="100" v-html="obtenFechaConFormato(Lista.FechaMovimiento)"></td> 
                                    <!-- <td width="150" v-html="DesglosaContenido(Lista.Movimientos)"></td>  -->
                                    <td width="350">{{Lista.Anexos}}</td>
                                    <td width="20" class="category_enabled text-center">
                                      <input v-model="EliminarDeLista" v-bind:value="Lista.InventarioDocumentoId" type="checkbox" @click="ChecaEliminar($event, Lista.InventarioDocumentoId)"/>
                                    </td>

                                </tr>
                            </tbody>
                        </table>
                        <div>
                            <label>Documentos seleccionadas para Recepción :  {{this.ARecibir.length}}</label>
                        </div>
                        <div class="text-right">
                          <button class="btn btn-sm btn-success" @click='Recibir()' v-if="ARecibir.length>0">Recepción de Documentos</button>
                          <button class="btn btn-sm btn-danger" @click='Eliminar()' v-if="EliminarDeLista.length>0">Eliminar de Listado</button>
                        </div>
                      </div>
                    </div>
                  </div>
              </div>
            </div>
        </div>
        <div v-if="this.MostrarEdicion==true">
          <EditVolumen :Volumen = this.VolumenAEditar @dialogo='EdicionModal($event)'></EditVolumen>
        </div>
    </div>
  </div>
</template>

<script>
import enumeraciones from '@/../static/js/enumeraciones'
import api from '@/../static/js/api'
import comun from '@/../static/js/comun'
import axios from 'axios'
import catalogos from '@/../static/js/catalogos'
import router from '@/router/index'
import LogoPJE from '@/../src/assets/logo-pj-transparente-negro.png'
import Volumen from '@/components/ArchivoJudicial/Movimientos/Recepcion/ModalEditVolumen.vue'

export default {
    components : {
      CAreas : catalogos.ArchivoJudicial.C001Areas,
      EditVolumen: Volumen
    },
    data(){
        return{
            enumeraciones,
            ListaDocumentos: [],
            ListaConFormatoExpedientes:[],
            ListaConFormatoExpedientesPenales:[],
            ListaConFormatoAmparos:[],
            ListaConFormatoAmparosPenales:[],
            ListaConFormatoExhortos:[],
            ListaConFormatoExhortosPenales:[],
            ListaConFormatoOtros:[],
            ListaConDigitales:[],
            ListaConAdministrativas :[],
            ListaConEjecucion : [],
            ListaConJuicio : [],
            ListaConTocasCiviles: [],
            ListaConTocasPenales : [],
            ListaConTocasOrales : [],
            ListaConTocasOralADO : [],
            ListaConTocasOralEJE : [],
            ARecibir:[],
            AreaEtiqueta:"",
            BusquedaForm: {
                parametros_Area: {
                    areaId: -1,
                    Nombre: "",
                    conMaterias: true,
                    Materias: [ { MateriaId: 1, Activo: true },{ MateriaId: 2, Activo: true }, { MateriaId: 3, Activo: true }, { MateriaId: 4, Activo: true }, { MateriaId: 5, Activo: true } , { MateriaId: 6, Activo: true }, { MateriaId: 9, Activo: true }, { MateriaId: 13, Activo: true } ], 
                    conOrdenamientoPorSistema:true
                }
            },
            UsuarioArchivo: {},
            VolumenAEditar: {},
            MostrarEdicion : false,
            EliminarDeLista : [],
            listaPreviaSinFiltro : [],
            ListadoDeFechas:[]
            }
    },
    props: {
      codigoDeBarras: "",
      update: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      cambioDeArea(datos){
            this.BusquedaForm.parametros_Area.areaId = parseInt(datos[0].target.value);
            this.BusquedaForm.parametros_Area.Nombre = datos[0].target.selectedOptions[0].text
            this.ListaDocumentos = []
      },
      obtenFechaConFormato: function(fechaRegistro) {
        return moment(fechaRegistro).format("DD-MM-YYYY");
      },
      ObtenDocumentos: async function(){
        this.AreaEtiqueta = this.BusquedaForm.parametros_Area.Nombre.toUpperCase();
        this.ListaConFormatoExpedientes= [];
        this.ListaConFormatoExpedientesPenales= [];
        this.ListaConFormatoAmparos = [];
        this.ListaConFormatoAmparosPenales = [];
        this.ListaConFormatoExhortos = [];
        this.ListaConFormatoExhortosPenales = [];
        this.ListaConFormatoOtros = [];
        this.ListaConDigitales= [];
        this.ListaConAdministrativas = [];
        this.ListaConJuicio = [];
        this.ListaConEjecucion = [];
        this.ListaConTocasCiviles = [];
        this.ListaConTocasPenales = [];
        this.ListaConTocasOrales = [];
        this.ListaConTocasOralADO = [];
        this.ListaConTocasOralEJE = [];
        this.ARecibir = [];
        this.listaPreviaSinFiltro = [];
        this.ListadoDeFechas = []
        var peticion = {
                "AreaId" : this.BusquedaForm.parametros_Area.areaId
            };
            comun.SeEstaCargandoInformacion(true);
            axios.post(api.conexion + api.ArchivoJudicial.ArchivoParaRecepcion, peticion,
            comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal))
            .then( respuesta => {
                if(respuesta.data.SiHayError)
                {
                    console.log(respuesta);
                    comun.SeEstaCargandoInformacion(false);
                    comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                }
                else
                {
                    var ListaObtenida= respuesta.data.GetListaParaRecepcion;
                    comun.SeEstaCargandoInformacion(false);
                    if(ListaObtenida.length>0)
                    {
                      this.DarFormatoListado(ListaObtenida);
                      //this.$nextTick(()=> { PaginarTabla('ListaArchivo_table', 10)});
                    }
                    else{
                      comun.mensajeDeAlerta("No hay Documentos para Recepción", null, null);
                    }
                    this.UsuarioArchivo =  respuesta.data.getUsuario;
                }
                comun.SeEstaCargandoInformacion(false);
                })
            .catch(excepcion => {
                    console.log(excepcion);
                    console.log("fallo por parametros");
                    comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                    comun.SeEstaCargandoInformacion(false);

            })
      },
      DarFormatoListado(Lista){
        var ListaPreliminar =[];
        $.each(Lista, function (index, movIds){
           
              ListaPreliminar.push(
                {
                  "MovimientoDocumentoId": movIds.MovimientoDocumentoId,
                  "InventarioDocumentoId": movIds.VolumenId !=null ? movIds.Volumen.Inventario.InventarioDocumentoId : (movIds.IncidenteId !=null ? movIds.Incidente.Inventario.InventarioDocumentoId : movIds.Terceria.Inventario.InventarioDocumentoId),
                  "TipoDocumento": movIds.VolumenId !=null ? movIds.Volumen.Inventario.TipoDocumento : (movIds.IncidenteId != null ? movIds.Incidente.Inventario.TipoDocumento : movIds.Terceria.Inventario.TipoDocumento),
                  "Materia": movIds.VolumenId !=null ? movIds.Volumen.Inventario.Materia : (movIds.IncidenteId != null ? movIds.Incidente.Inventario.Materia : movIds.Terceria.Inventario.Materia),
                  "Anio": movIds.VolumenId !=null ? movIds.Volumen.Inventario.Anio : ( movIds.IncidenteId !=null ? movIds.Incidente.Inventario.Anio : movIds.Terceria.Inventario.Anio),
                  "Consecutivo": movIds.VolumenId !=null ? movIds.Volumen.Inventario.Consecutivo : (movIds.IncidenteId!= null ? movIds.Incidente.Inventario.Consecutivo : movIds.Terceria.Inventario.Consecutivo),
                  "Sufijo" : movIds.VolumenId !=null ? movIds.Volumen.Inventario.Sufijo : (movIds.IncidenteId!= null ? movIds.Incidente.Inventario.Sufijo : movIds.Terceria.Inventario.Sufijo),
                  "AreaQuePresta": movIds.AreaQuePresta,
                  "UsuarioQuienPresta": movIds.UsuarioQuienPresta,
                  "FechaMovimiento": movIds.FechaMovimiento,
                  "VolumenId": movIds.VolumenId,
                  "Volumen": movIds.Volumen,
                  "IncidenteId": movIds.IncidenteId,
                  "Incidente": movIds.Incidente,
                  "TerceriaId": movIds.TerceriaId,
                  "Terceria": movIds.Terceria,
                  "SedeArchivo": movIds.VolumenId !=null ? movIds.Volumen.Inventario.SedeArchivo : ( movIds.IncidenteId!=null ? movIds.Incidente.Inventario.SedeArchivo : movIds.Terceria.Inventario.SedeArchivo),
                  "Anexos": movIds.VolumenId!=null ? movIds.Volumen.Inventario.Anexos : ( movIds.IncidenteId!=null ? movIds.Incidente.Inventario.Anexos : movIds.Terceria.Inventario.Anexos),
                  "Observaciones": movIds.Observaciones,
                  "TiposMovimientos": movIds.TiposMovimientos,
                  "FechaRecepcion": movIds.FechaRecepcion
                })
            
            
        });
        
        this.listaPreviaSinFiltro = this.AgruparInventarioDocumentoId(ListaPreliminar);
        //console.log(this.listaPreviaSinFiltro)
      },
      AgruparInventarioDocumentoId(datos){
        
        var ListaInicial=[];
        var FechasEnLista = [];
        $.each(datos, function(index, listado){
          
         
            var chequeo = ListaInicial.find(e=>e.InventarioDocumentoId == listado.InventarioDocumentoId);
            if(chequeo == undefined || chequeo == false)
            {
               
                ListaInicial.push({"InventarioDocumentoId": listado.InventarioDocumentoId,
                                "TipoDocumento": listado.TipoDocumento,
                                "Anio": listado.Anio,
                                "Consecutivo": listado.Consecutivo,
                                "SedeArchivo": listado.SedeArchivo,
                                "Volumenes": listado.Volumen,
                                "Anexos": listado.Anexos,
                                "FechaMovimiento": listado.FechaMovimiento,
                                "Materia" : listado.Materia,
                                "Sufijo" : listado.Sufijo,
                                "Movimientos": [
                                  {
                                    "MovimientoDocumentoId": listado.MovimientoDocumentoId,
                                    "FechaMovimiento": listado.FechaMovimiento,
                                    "UsuarioQuienPresta": listado.UsuarioQuienPresta,
                                    "AreaQuePresta": listado.AreaQuePresta,
                                    "IncidenteId": listado.IncidenteId,
                                    "Incidentes": listado.Incidente!= null? listado.Incidente : null,
                                    "VolumenId": listado.VolumenId,
                                    "Volumenes": listado.Volumen!=null ? listado.Volumen : null,
                                    "TerceriaId": listado.TerceriaId,
                                    "Tercerias": listado.Terceria!=null ? listado.Terceria : null,
                                    "TiposMovimientos": listado.TiposMovimientos,
                                    "FechaRecepcion":listado.FechaRecepcion
                                  }],
                                "Observaciones": listado.Observaciones
                                });
            }
            else{
              
                  chequeo.Movimientos.push({
                                      "MovimientoDocumentoId": listado.MovimientoDocumentoId,
                                      "FechaMovimiento": listado.FechaMovimiento,
                                      "UsuarioQuienPresta": listado.UsuarioQuienPresta,
                                      "AreaQuePresta": listado.AreaQuePresta,
                                      "IncidenteId": listado.IncidenteId,
                                      "Incidentes": listado.Incidente!= null? listado.Incidente : null,
                                      "VolumenId": listado.VolumenId,
                                      "Volumenes": listado.Volumen!=null ? listado.Volumen : null,
                                      "TerceriaId": listado.TerceriaId,
                                      "Tercerias": listado.Terceria!=null ? listado.Terceria : null,
                                      "TiposMovimientos": listado.TiposMovimientos,
                                      "FechaRecepcion":listado.FechaRecepcion});
                
            }
        });
        $.each(ListaInicial, function(id, elemento){
          var checkFecha = FechasEnLista.find(e=>e.FechaMovimiento==moment(elemento.FechaMovimiento).format('DD/MM/YYYY'));
          if(checkFecha==undefined || checkFecha==false)
          {
            FechasEnLista.push({
              "Id": id,
              "FechaMovimiento": moment(elemento.FechaMovimiento).format('DD/MM/YYYY'),
              "FechaFormato" : moment(elemento.FechaMovimiento).format('DD/MM/YYYY')
            })
          }
        });
        this.ListadoDeFechas = FechasEnLista;//.sort((a,b)=>(a.FechaMovimiento<b.FechaMovimiento ? 1:-1));
        return ListaInicial;
      },
      Recibir() {
            var Movimientos = [];
            let Documentos = this.Seleccion();
            var ListaRecepcion = [];
            if(Documentos.length>0)
             {
               
               $.each(Documentos, function(indice, documento)
                {
                  ListaRecepcion.push(documento.InventarioDocumentoId);
                  $.each(documento.Movimientos, function(indice, movimiento)
                  {
                    Movimientos.push(movimiento);
                    if(movimiento.Volumenes!=null && movimiento.Volumenes.Amparos!=null && movimiento.Volumenes.Amparos.length>0)
                    {
                      $.each(movimiento.Volumenes.Amparos, function(id, amparo)
                      {
                        Movimientos.push({
                          "MovimientoDocumentoId": null,
                          "AreaQuePresta": movimiento.AreaQuePresta,
                          "AreaQueRecibe": {"AreaId": 21},
                          "UsuarioQuienPresta": movimiento.UsuarioQuienPresta,
                          "FechaMovimiento": movimiento.FechaMovimiento,
                          "VolumenId": amparo.AmparosDelDocumento.Volumenes[0].VolumenId,
                          "TiposMovimientos": movimiento.TiposMovimientos
                        });
                        ListaRecepcion.push(amparo.AmparosDelDocumento.InventarioDocumentoId)
                      })
                    }
                  });
                  
                });
               var peticion={
                    Movimientos, ListaRecepcion
                };
              //comun.SeEstaCargandoInformacion(true);
              axios.post(api.conexion + api.ArchivoJudicial.RecepecionPrimeraVez, peticion,
              comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal))
              .then( respuesta => {
              if(respuesta.data.SiHayError)
                {
                  console.log(respuesta);
                  //comun.SeEstaCargandoInformacion(false);
                  comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                  this.ARecibir = [];
                  this.ObtenDocumentos();
                }
                else
                {  

                  var usuario = this.UsuarioArchivo;
                  this.ObtenDocumentos();
                  comun.mensajeDeAlerta("Se Registrado la Recepción de Documento(s) en Archivo General.");
                }

                })
                .catch(excepcion => {
                console.log(excepcion);
                console.log("fallo por parametros");
                comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                comun.SeEstaCargandoInformacion(false);
                });
                
            }
            else
            {
              comun.mensajeDeAlerta("Seleccione Documentos para Recepción", null, null);
            }
      },
      Seleccion(){
            let documentosSeleccionados = [];
            this.ARecibir.forEach((element) =>{
                let agregaDocumentoExpediente = this.ListaConFormatoExpedientes.find(sol=>sol.InventarioDocumentoId == element);
                let agregaDocumentoExpedientePenal = this.ListaConFormatoExpedientesPenales.find(sol=>sol.InventarioDocumentoId == element);
                let agregaDocumentoAmparo = this.ListaConFormatoAmparos.find(sol=>sol.InventarioDocumentoId == element);
                let agregaDocumentoAmparoPenal = this.ListaConFormatoAmparosPenales.find(sol=>sol.InventarioDocumentoId == element);
                let agregaDocumentoExhorto = this.ListaConFormatoExhortos.find(sol=>sol.InventarioDocumentoId == element);
                let agregaDocumentoExhortoPenal = this.ListaConFormatoExhortosPenales.find(sol=>sol.InventarioDocumentoId == element);
                let agregaDocumentoOtros = this.ListaConFormatoOtros.find(sol=>sol.InventarioDocumentoId == element);
                if(agregaDocumentoExpediente!=undefined)
                {
                  documentosSeleccionados.push(agregaDocumentoExpediente);
                };
                if (agregaDocumentoAmparo!=undefined)
                {
                  documentosSeleccionados.push(agregaDocumentoAmparo);
                };
                if(agregaDocumentoExhorto!=undefined)
                {
                  documentosSeleccionados.push(agregaDocumentoExhorto);
                };
                if(agregaDocumentoExpedientePenal!=undefined)
                {
                  documentosSeleccionados.push(agregaDocumentoExpedientePenal);
                };
                if (agregaDocumentoAmparoPenal!=undefined)
                {
                  documentosSeleccionados.push(agregaDocumentoAmparoPenal);
                };
                if(agregaDocumentoExhortoPenal!=undefined)
                {
                  documentosSeleccionados.push(agregaDocumentoExhortoPenal);
                };
                if(agregaDocumentoOtros!=undefined)
                {
                  documentosSeleccionados.push(agregaDocumentoOtros);
                }
                
            });
            return documentosSeleccionados;
      },
      seleEliminar(){
        let documentosSeleccionados = [];
        
        this.EliminarDeLista.forEach((element) =>{
          let agregaDocumentoExpediente = this.ListaConFormatoExpedientes.find(sol=>sol.InventarioDocumentoId == element);
          let agregaDocumentoExpedientePenal = this.ListaConFormatoExpedientesPenales.find(sol=>sol.InventarioDocumentoId == element);
          let agregaDocumentoAmparo = this.ListaConFormatoAmparos.find(sol=>sol.InventarioDocumentoId == element);
          let agregaDocumentoAmparoPenal = this.ListaConFormatoAmparosPenales.find(sol=>sol.InventarioDocumentoId == element);
          let agregaDocumentoExhorto = this.ListaConFormatoExhortos.find(sol=>sol.InventarioDocumentoId == element);
          let agregaDocumentoExhortoPenal = this.ListaConFormatoExhortosPenales.find(sol=>sol.InventarioDocumentoId == element);
          let agregaDocumentoOtros = this.ListaConFormatoOtros.find(sol=>sol.InventarioDocumentoId == element);
                if(agregaDocumentoExpediente!=undefined)
                {
                  documentosSeleccionados.push(agregaDocumentoExpediente);
                };
                if (agregaDocumentoAmparo!=undefined)
                {
                  documentosSeleccionados.push(agregaDocumentoAmparo);
                };
                if(agregaDocumentoExhorto!=undefined)
                {
                  documentosSeleccionados.push(agregaDocumentoExhorto);
                };
                if(agregaDocumentoExpedientePenal!=undefined)
                {
                  documentosSeleccionados.push(agregaDocumentoExpedientePenal);
                };
                if (agregaDocumentoAmparoPenal!=undefined)
                {
                  documentosSeleccionados.push(agregaDocumentoAmparoPenal);
                };
                if(agregaDocumentoExhortoPenal!=undefined)
                {
                  documentosSeleccionados.push(agregaDocumentoExhortoPenal);
                };
                if(agregaDocumentoOtros!=undefined)
                {
                  documentosSeleccionados.push(agregaDocumentoOtros);
                }
              // let agregaDocumentoExpediente = this.ListaConFormatoExpedientes.find(sol=>sol.InventarioDocumentoId == element);
              // let agregaDocumentoAmparo = this.ListaConFormatoAmparos.find(sol=>sol.InventarioDocumentoId == element);
              // let agregaDocumentoExhorto = this.ListaConFormatoExhortos.find(sol=>sol.InventarioDocumentoId == element);
              // let agregaDocumentoOtros = this.ListaConFormatoOtros.find(sol=>sol.InventarioDocumentoId == element);
              //   if(agregaDocumentoExpediente!=undefined)
              //   {
              //     documentosSeleccionados.push(agregaDocumentoExpediente);
              //   }
              //   else
              //   {
              //     if (agregaDocumentoAmparo!=undefined)
              //     {
              //       documentosSeleccionados.push(agregaDocumentoAmparo);
              //     }
              //     else
              //     {
              //       if(agregaDocumentoExhorto!=undefined)
              //       {
              //         documentosSeleccionados.push(agregaDocumentoExhorto);
              //       }
              //       else
              //       {
              //         if(agregaDocumentoOtros!=undefined)
              //         {
              //           documentosSeleccionados.push(agregaDocumentoOtros);
              //         }
              //       }
              //     }
              //   }
            });
        console.log(documentosSeleccionados)
        return documentosSeleccionados;
      },
      Eliminar(){
        var MovimientosAEliminar = [];
        let Documentos = this.seleEliminar();
         $.each(Documentos, function(indice, documento)
         {
           $.each(documento.Movimientos, function(indice, movimiento)
            {
                MovimientosAEliminar.push(movimiento)
            });
         });
        var peticion = {MovimientosAEliminar}
        bootbox.confirm({
          title: "Mensaje del sistema",
          message: "Desea Eliminar los documentos seleccionados en Recepción?",
          buttons: {
            cancel: {
              label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
            },
            confirm: {
              label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Aceptar'
            }
          },
          callback: (respuestaSalir) => {
            if (respuestaSalir) {
              //comun.SeEstaCargandoInformacion(true);
              axios.post(api.conexion + api.ArchivoJudicial.EliminarDeLista, peticion,
              comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal))
              .then( respuesta => {
              if(respuesta.data.SiHayError)
                {
                  console.log(respuesta);
                  comun.SeEstaCargandoInformacion(false);
                  comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                  this.ARecibir = [];
                }
                else
                {   
                  //comun.SeEstaCargandoInformacion(false);
                  comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
                  this.ObtenDocumentos();
                  this.ARecibir = [];
                  this.EliminarDeLista = [];
                  // this.ListaConFormatoExpedientes = [];
                  // this.ListaConFormatoAmparos = [];
                  // this.ListaConFormatoExhortos = [];
                  // this.ListaConFormatoOtros=[];
                }
                //comun.SeEstaCargandoInformacion(false);
                })
                .catch(excepcion => {
                console.log(excepcion);
                console.log("fallo por parametros");
                comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                comun.SeEstaCargandoInformacion(false);
              }); 
            }
          }
        });
      },
      ImprimirDocumento: function(Listado){
          var Contador = 0;
          let _this = this;
            
            var printWin = window.open('', '_blank', 'width=600,height=720,location=no,left=100px');
            printWin.document.open();
            printWin.document.write('<html><head><title>Archivo Judicial</title>');
            printWin.document.write('<link rel="" href="/src/assets/favicon.ico">');
            printWin.document.write('<link href="/static/css/bootstrap.min.css" rel="stylesheet">');
            printWin.document.write('<link href="/static/css/all.min.css" rel="stylesheet">');
            printWin.document.write('<link href="/static/css/bootstrap-table.min.css" rel="stylesheet">');
            printWin.document.write('</head><body>');
            printWin.document.write('<div class="col-md-12">');
            printWin.document.write('<div class="area">');
            printWin.document.write('<div class="row">');
            printWin.document.write('<div class="form-group col-3 align-self-center">');
            printWin.document.write('<img src="' + LogoPJE +'" width="185" height="150" alt="Logo de Poder Judicial del Estado de Aguascalientes"/></div>');
            printWin.document.write('<div class="form-group col-6 text-center align-self-center">');
            printWin.document.write('<h5 class="text-center">DIRECCIÓN DEL ARCHIVO JUDICIAL</h5></div>');
            printWin.document.write('<div class="form-group col-3"></div></div></div>');
            printWin.document.write('<div class="area"><div class="row">');
            printWin.document.write('<div class="form-group col-12 align-self-center" >');
            printWin.document.write('<div class="text-center">');
            printWin.document.write('<h5 class="text-center">LISTADO DE DOCUMENTOS PARA REGISTRO DE INVENTARIO</h5></div>');
            printWin.document.write('</div></div>');
            printWin.document.write('<div class="row">');
            printWin.document.write('<div class="form-group col-12 align-self-center" >');
            printWin.document.write('<div class="text-center">');
            printWin.document.write('<h6 class="text-center">RECEPCION</h6>');
            printWin.document.write('</div></div></div>');
            printWin.document.write('<div class="row">');
            printWin.document.write('<div class="form-group col-12 text-right">');
            printWin.document.write('<label>Aguascalientes, Ags., a  '+ moment().format('DD/MM/YYYY') + '</label>');
            printWin.document.write('</div></div>');
            printWin.document.write('<div class="row">');
            printWin.document.write('<div class="form-group col-12 ">');
            printWin.document.write('<label>Area: '+ _this.AreaEtiqueta +'</label>');
            printWin.document.write('</div></div></div>');
            printWin.document.write('<div class="area">');
            printWin.document.write('<div class="row">');
            printWin.document.write('<div class="form-group col-12">');
            printWin.document.write('<div class="table-reponsive">');
            printWin.document.write('<table class="table table-striped table-light table-bordered table-sm" style="display: block; page-break-before: auto;">');
            printWin.document.write('<thead><tr><th></th><th>Tipo Documento</th><th>Consecutivo</th><th >Sede</th><th >Fecha de Movimiento</th><th>Contenido</th>');
            printWin.document.write('<th>Observaciones</th></tr></thead><tbody class="text-dark">');
            //ciclo inicio
            $.each(Listado, function(index, Documento){
                Contador +=1
                var CadenaTexto = _this.DesglosaContenido(Documento.Movimientos)
                //var Rows = Documento.Movimientos.length;
                printWin.document.write('<tr style="page-break-inside:avoid; page-break-after:auto">');
                printWin.document.write('<td width ="30">'+ Contador +'</td>');
                printWin.document.write('<td width ="150">'+ Documento.TipoDocumento.Nombre +'</td>');
                printWin.document.write('<td width ="100">'+ Documento.Consecutivo + '/' + Documento.Anio+'</td>');
                printWin.document.write('<td width ="250">' + Documento.SedeArchivo.Nombre +'</td>');
                printWin.document.write('<td>'+ moment(Documento.Movimientos[0].FechaMovimiento).format('DD/MM/YYYY') + '</td>');
                printWin.document.write('<td width ="150">'+ CadenaTexto +'</td>');
                printWin.document.write('<td width ="250">'+ (Documento.Anexos!=null?Documento.Anexos: '') +'</td>');
                printWin.document.write('</tr>');
                  
            });
            //ciclo fin

            printWin.document.write('</tbody></table></div></div></div>');
            printWin.document.write('<div class="area" style="display: block; page-break-before: auto;">');
            printWin.document.write('<div class="row">');
            printWin.document.write('<div class="form-group col-1"></div>');
            printWin.document.write('<div class="form-group col-4 align-self-center" style="border: 1px solid black";>');
                        printWin.document.write('<br><br><br><br><br>');
                        printWin.document.write('       <div class="align-self-center text-center" style="border-top: 1px solid black; "');
                        printWin.document.write('           <div class="align-self-center"><label><strong>NOMBRE Y FIRMA</strong></label><div>');
                        printWin.document.write('       </div>');
                        printWin.document.write('       <div class="align-self-center">');
                        printWin.document.write('           <label><strong>ARCHIVO DE CONCENTRACIÓN</strong></label></div>');
                        printWin.document.write('       </div>');
                        printWin.document.write('</div>');
                        printWin.document.write('<div class="form-group col-2"></div>');
                        printWin.document.write('<div class="form-group col-4 align-self-center" style="border: 1px solid black";>');
                        printWin.document.write('<br><br><br><br><br>');
                        printWin.document.write('       <div class="align-self-center text-center" style="border-top: 1px solid black; "');
                        printWin.document.write('           <div class="align-self-center"><label><strong>NOMBRE Y FIRMA</strong></label><div>');
                        printWin.document.write('       </div>');
                        printWin.document.write('       <div class="align-self-center">');
                        printWin.document.write('           <label><strong>' + _this.AreaEtiqueta + '</strong></label></div>');
                        printWin.document.write('       </div>');
                        printWin.document.write('</div>');
                        printWin.document.write('<div class="form-group col-1"></div>');
                        printWin.document.write('</div>');

            
            printWin.document.write('</div>');
            printWin.document.write('</div>');
 
            printWin.document.write('</body></html>');
            var css = '@page { size: Legal;  margin: 25mm 15mm 25mm 15mm; }',
            head = printWin.document.head || document.getElementsByTagName('head')[0],
            style = printWin.document.createElement('style');

            style.type = 'text/css';
            style.media = 'print';

            if (style.styleSheet) {
            style.styleSheet.cssText = css;
            } else {
            style.appendChild(printWin.document.createTextNode(css));
            }
            head.appendChild(style);
            setTimeout(function(){ printWin.print(); }, 1000)
            printWin.document.close();
            printWin.focus();
      },
      EditarFojas(datos){
        this.VolumenAEditar = datos;
        this.MostrarEdicion = true;
      },
      EdicionModal(datos){
        console.log(datos);
        this.MostrarEdicion = datos.Estatus;
        if(datos.Actualizaion==true)
        {
          this.ObtenDocumentos();
        }
      },
      DesglosaContenido: function (datos){
        
        let Contenido ="";
        let sumaTomos=0;
        let sumaIncidentes=0;
        let sumaTercerias=0;
        let Amparos="";
        $.each(datos, function(index, movimiento)
        {
          if(movimiento.Volumenes!=null)
          { 
            sumaTomos++;
            if(movimiento.Volumenes.NumVolumen==1)
            {
              if(movimiento.Volumenes.Amparos.length>0)
              {
                $.each(movimiento.Volumenes.Amparos, function(id, amparo)
                {
                  Amparos = Amparos + amparo.AmparosDelDocumento.Consecutivo + "/" + amparo.AmparosDelDocumento.Anio + " "
                })
              }
              // if(movimiento.Volumenes.IncidenteVolumen!=null && movimiento.Volumenes.IncidenteVolumen.length>0)
              //     {
              //       sumaIncidentes = sumaIncidentes + movimiento.Volumenes.IncidenteVolumen.length;
              // }
            }
            
          }
          if(movimiento.Incidentes!=null)
            {
              sumaIncidentes ++; 
          }
          if(movimiento.Tercerias!=null)
            {
              sumaTercerias ++;
          };
          
        });
        if(sumaTomos>1)
        {
          Contenido= Contenido +"<b>Tomos :</b>" + sumaTomos + "<br/>";
        };
        if(Amparos!="")
        {
          Contenido=Contenido + "<b>Amparos :</b> " + Amparos + "<br/>"
        }
        if(sumaIncidentes>0)
        {
          Contenido= Contenido +"<b>Incidentes :</b>" + sumaIncidentes + "<br/>";
        }
        if(sumaTercerias>0)
        {
          Contenido= Contenido +"<b>Tercerias :</b>" + sumaTercerias + "<br/>";
        }
            return Contenido;
      },
      ChecaEliminar(evento, id){
        if(evento.target.checked)
        {
          var buscaEnRecepcion = this.ARecibir.filter(e=>e == id);
          if(buscaEnRecepcion.length>0)
          {
            comun.mensajeDeAlerta("Este documento fue seleccionado en recepción, cambia a selección en eliminación", null, null);
            let index = this.ARecibir.indexOf(id);
            this.ARecibir.splice(index,1);
          }
        }
      },
      ChecaRecepcion(evento, id){
        if(evento.target.checked)
        {
          var buscaEnElimina = this.EliminarDeLista.filter(e=>e == id);
          if(buscaEnElimina.length>0)
          {
            comun.mensajeDeAlerta("Este documento fue seleccionado en eliminación, cambia a selección en recepción", null, null);
            let index = this.EliminarDeLista.indexOf(id);
            this.EliminarDeLista.splice(index,1);
          }
        }
      },
      sortAnioConsecutivo: function (a,b)
        {
            //if(a.FechaMovimiento < b.FechaMovimiento) return -1
            //if(a.FechaMovimiento > b.FechaMovimiento) return 1
            if(a.Anio < b.Anio) return -1
            if(a.Anio > b.Anio) return 1
            if(a.Consecutivo < b.Consecutivo) return -1
            if(a.Consecutivo > b.Consecutivo) return 1
            return 0
      }, 
      EliminarRecibidos(recibidos){
        let _this= this;
        
        $('#navrecepcion_tablePrincipal').remove();
        $('#navrecepcion_tableAmparos').remove();
        $('#navrecepcion_tableExortos').remove();
        $('#navrecepcion_tableDigitales').remove();
        $('#navrecepcion_tableAdministrativas').remove();
        $('#navrecepcion_tableEjecucion').remove();
        $('#navrecepcion_tableJuicio').remove();
        $.each(recibidos, function(id, numero)
        {
          let expediente = _this.ListaConFormatoExpedientes.find(e=>e.InventarioDocumentoId==numero);
          let amparo = _this.ListaConFormatoAmparos.find(e=>e.InventarioDocumentoId==numero)
          let exhorto = _this.ListaConFormatoExhortos.find(e=>e.InventarioDocumentoId==numero)
          let otro = _this.ListaConFormatoOtros.find(e=>e.InventarioDocumentoId==numero);
          let administrativas = _this.ListaConAdministrativas.find(e=>e.InventarioDocumentoId==numero);
          let digitales = _this.ListaConDigitales.find(e=>e.InventarioDocumentoId==numero);
          let juicio = _this.ListaConJuicio.find(e=>e.InventarioDocumentoId==numero);
          let ejecucion = _this.ListaConEjecucion.find(e=>e.InventarioDocumentoId==numero)

          if(expediente!=null && expediente!=undefined)
          {
            var Index = _this.ListaConFormatoExpedientes.indexOf(expediente);
            _this.ListaConFormatoExpedientes.splice(Index,1);
          };
          if(amparo!=null && amparo!=undefined)
          {
            var Index = _this.ListaConFormatoAmparos.indexOf(amparo);
            _this.ListaConFormatoAmparos.splice(Index,1);
          };
          if(exhorto!=null && exhorto!=undefined)
          {
            var Index = _this.ListaConFormatoExhortos.indexOf(exhorto);
            _this.ListaConFormatoExpedientes.splice(Index,1);
          };
          if(otro!=null && otro!=undefined)
          {
            var Index = _this.ListaConFormatoOtros.indexOf(otro);
            _this.ListaConFormatoOtros.splice(Index,1);
          };

          if(digitales!=null && digitales!=undefined)
          {
            var Index = _this.ListaConDigitales.indexOf(otro);
            _this.ListaConDigitales.splice(Index,1);
          };
          if(administrativas!=null && administrativas!=undefined)
          {
            var Index = _this.ListaConAdministrativas.indexOf(otro);
            _this.ListaConAdministrativas.splice(Index,1);
          };
          if(juicio!=null && juicio!=undefined)
          {
            var Index = _this.ListaConJuicio.indexOf(otro);
            _this.ListaConJuicio.splice(Index,1);
          };
          if(ejecucion!=null && ejecucion!=undefined)
          {
            var Index = _this.ListaConEjecucion.indexOf(otro);
            _this.ListaConEjecucion.splice(Index,1);
          };

        });
        this.ARecibir=[];
        this.ListaConFormatoExpedientes.sort(this.sortAnioConsecutivo);
        this.ListaConFormatoAmparos.sort(this.sortAnioConsecutivo);
        this.ListaConFormatoExhortos.sort(this.sortAnioConsecutivo);
        this.ListaConFormatoOtros.sort(this.sortAnioConsecutivo);
        this.ListaConDigitales.sort(this.sortAnioConsecutivo);
        this.ListaConAdministrativas.sort(this.sortAnioConsecutivo);
        this.ListaConJuicio.sort(this.sortAnioConsecutivo);
        this.ListaConEjecucion.sort(this.sortAnioConsecutivo);

        this.$nextTick(()=> { PaginarTabla('recepcion_tablePrincipal', 15)});
        this.$nextTick(()=> { PaginarTabla('recepcion_tableAmparos', 15)});
        this.$nextTick(()=> { PaginarTabla('recepcion_tableExortos', 15)});
        this.$nextTick(()=> { PaginarTabla('recepcion_tableDigitales', 15)});
        this.$nextTick(()=> { PaginarTabla('recepcion_tableAdministrativas', 15)});
        this.$nextTick(()=> { PaginarTabla('recepcion_tableEjecucion', 15)});
        this.$nextTick(()=> { PaginarTabla('recepcion_tableJuicios', 15)});
      },
      cambiarFechaListado(datos){
            var obtenido = parseInt(datos.target.value);
            this.ARecibir=[];
            this.EliminarDeLista=[];
            $('#navrecepcion_tablePrincipal').remove();
            $('#navrecepcion_tableAmparos').remove();
            $('#navrecepcion_tableExortos').remove();
            $('#navrecepcion_tableDigitales').remove();
            $('#navrecepcion_tableAdministrativas').remove();
            $('#navrecepcion_tableEjecucion').remove();
            $('#navrecepcion_tableJuicio').remove();
            $('#navrecepcion_tableExpPenales').remove();
            $('#navrecepcion_tableAmparosPenales').remove();
            $('#navrecepcion_tableExhortosPenales').remove();
            $('#navrecepcion_tableTocasCiviles').remove();
            $('#navrecepcion_tableTocasPenales').remove();
            $('#navrecepcion_tableTocasOrales').remove();
            $('#navrecepcion_tableTocasOralADO').remove();
            $('#navrecepcion_tableTocasOralEJE').remove();

            //console.log(this.listaPreviaSinFiltro)
            if (obtenido>=0)
            {
              var fecha=this.ListadoDeFechas.find(a=>a.Id==obtenido);
              var temporal = this.listaPreviaSinFiltro.filter(z=>moment(z.FechaMovimiento).format('DD/MM/YYYY')==fecha.FechaMovimiento);
              //this.ListaConFormato.sort(this.sortAnioConsecutivo);
              if(this.BusquedaForm.parametros_Area.areaId!=48 && this.BusquedaForm.parametros_Area.areaId!=51 && this.BusquedaForm.parametros_Area.areaId!=52 && this.BusquedaForm.parametros_Area.areaId!=53 && this.BusquedaForm.parametros_Area.areaId!=54)
              {
                  this.ListaConFormatoExpedientes= temporal.filter(e=>e.TipoDocumento.TipoDocumentoId==1 && e.Materia.MateriaId!=6).sort(this.sortAnioConsecutivo);//!=null ? temporal.filter(e=>e.TipoDocumento.TipoDocumentoId==1 && e.Materia.MateriaId!=6).sort(this.sortAnioConsecutivo) : [];
                  this.ListaConFormatoExpedientesPenales= temporal.filter(e=>e.TipoDocumento.TipoDocumentoId==1 && e.Materia.MateriaId==6).sort(this.sortAnioConsecutivo);
                  this.ListaConFormatoAmparos = temporal.filter(e=>e.TipoDocumento.TipoDocumentoId==4 && e.Materia.MateriaId!=6).sort(this.sortAnioConsecutivo);
                  this.ListaConFormatoAmparosPenales = temporal.filter(e=>e.TipoDocumento.TipoDocumentoId==4 && e.Materia.MateriaId==6).sort(this.sortAnioConsecutivo);
                  this.ListaConFormatoExhortos = temporal.filter(e=>e.TipoDocumento.TipoDocumentoId==5 && e.Materia.MateriaId!=6).sort(this.sortAnioConsecutivo);
                  this.ListaConFormatoExhortosPenales = temporal.filter(e=>e.TipoDocumento.TipoDocumentoId==5 && e.Materia.MateriaId==6).sort(this.sortAnioConsecutivo);
                  this.ListaConFormatoOtros = temporal.filter(e=>e.TipoDocumento.TipoDocumentoId!=1 && e.TipoDocumento.TipoDocumentoId!=4 && e.TipoDocumento.TipoDocumentoId!=5).sort(this.sortAnioConsecutivo);
                  this.ListaConTocasCiviles = temporal.filter(e=>e.TipoDocumento.TipoDocumentoId==16 && e.Materia.MateriaId!=6).sort(this.sortAnioConsecutivo);
                  this.ListaConTocasPenales = temporal.filter(e=>e.TipoDocumento.TipoDocumentoId==16 && e.Materia.MateriaId==6).sort(this.sortAnioConsecutivo);
                  this.ListaConDigitales= temporal.filter(e=>e.TipoDocumento.TipoDocumentoId==23).sort(this.sortAnioConsecutivo);
                  this.ListaConAdministrativas = temporal.filter(e=>e.TipoDocumento.TipoDocumentoId==24).sort(this.sortAnioConsecutivo);
                  this.ListaConTocasOrales = temporal.filter(e=>e.TipoDocumento.TipoDocumentoId==29 && e.Materia.MateriaId==6).sort(this.sortAnioConsecutivo);
                  this.ListaConTocasOralADO = temporal.filter(e=>e.TipoDocumento.TipoDocumentoId==30 && e.Materia.MateriaId==6).sort(this.sortAnioConsecutivo);
                  this.ListaConTocasOralEJE = temporal.filter(e=>e.TipoDocumento.TipoDocumentoId==31 && e.Materia.MateriaId==6).sort(this.sortAnioConsecutivo);
              }
              else
              {
                  this.ListaConDigitales= temporal.filter(e=>e.TipoDocumento.TipoDocumentoId==23).sort(this.sortAnioConsecutivo);
                  this.ListaConAdministrativas = temporal.filter(e=>e.TipoDocumento.TipoDocumentoId==24).sort(this.sortAnioConsecutivo);
                  this.ListaConJuicio = temporal.filter(e=>e.TipoDocumento.TipoDocumentoId==27).sort(this.sortAnioConsecutivo);
                  this.ListaConEjecucion = temporal.filter(e=>e.TipoDocumento.TipoDocumentoId==26).sort(this.sortAnioConsecutivo);
                  this.ListaConFormatoExhortos = temporal.filter(e=>e.TipoDocumento.TipoDocumentoId==5).sort(this.sortAnioConsecutivo);
                  this.ListaConFormatoOtros = temporal.filter(e=>e.TipoDocumento.TipoDocumentoId!=1 && e.TipoDocumento.TipoDocumentoId!=4 && e.TipoDocumento.TipoDocumentoId!=5).sort(this.sortAnioConsecutivo);
              }
            }
            else
            {
                this.ListaConFormatoExpedientes= [];
                this.ListaConFormatoAmparos = [];
                this.ListaConFormatoExhortos = [];
                this.ListaConFormatoOtros = [];
                this.ListaConDigitales= [];
                this.ListaConAdministrativas = [];
                this.ListaConJuicio = [];
                this.ListaConEjecucion = [];
                this.ListaConTocasCiviles = [];
                this.ListaConTocasPenales=[];
                this.ListaConTocasOrales = [];
                this.ListaConTocasOralADO = [];
                this.ListaConTocasOralEJE = [];

            };
            this.$nextTick(()=> { PaginarTabla('recepcion_tablePrincipal', 15)});
            this.$nextTick(()=> { PaginarTabla('recepcion_tableAmparos', 15)});
            this.$nextTick(()=> { PaginarTabla('recepcion_tableExortos', 15)});
            this.$nextTick(()=> { PaginarTabla('recepcion_tableDigitales', 15)});
            this.$nextTick(()=> { PaginarTabla('recepcion_tableAdministrativas', 15)});
            this.$nextTick(()=> { PaginarTabla('recepcion_tableEjecucion', 15)});
            this.$nextTick(()=> { PaginarTabla('recepcion_tableJuicios', 15)});
            this.$nextTick(()=> { PaginarTabla('recepcion_tableExpPenales', 15)});
            this.$nextTick(()=> { PaginarTabla('recepcion_tableAmparosPenales', 15)});
            this.$nextTick(()=> { PaginarTabla('recepcion_tableExhortosPenales', 15)});
            this.$nextTick(()=> { PaginarTabla('recepcion_tableTocasCiviles', 15)});
            this.$nextTick(()=> { PaginarTabla('recepcion_tableTocasPenales', 15)});
            this.$nextTick(()=> { PaginarTabla('recepcion_tableTocasOrales', 15)});
            this.$nextTick(()=> { PaginarTabla('recepcion_tableTocasOralADO', 15)});
            this.$nextTick(()=> { PaginarTabla('recepcion_tableTocasOralEJE', 15)});
            
      }
    }
}      
  
</script>
<style scoped>
input[type="text"]:read-only {
    background: #504f54;
  }

input[type="text"]:read-only:focus {
      color: #fff;
    }
#modalSolicitud{
    overflow-y:auto;
    max-height: 500px;
  }
</style>


// WEBPACK FOOTER //
// src/components/ArchivoJudicial/Movimientos/Recepcion/RecepcionArchivo.vue